/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { SiteReadingsState } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import { getSiteReadingsById, GetSiteReadingsByIdDto } from '@/jsonapi/SiteReadings'
import { addOrUpdateSameKeyObjectInArray, callApiWithoutDuplicate } from '@/store/utils/api'

const state: SiteReadingsState = {
  siteReadings: [],
}

const mutations = {
  [MutationNames.updateSiteReadings](state: SiteReadingsState, payload): void {
    state.siteReadings = payload
  },
}

const actions = {
  async [ActionNames.getSiteReadingsById]({ commit, state }, payload: GetSiteReadingsByIdDto): Promise<void> {
    const results = camelcaseKeysDeep(await getSiteReadingsById(payload))
    if (!results.length) {
      console.log('getSiteReadingsById length is falsy')
      return
    }

    // const cloneSiteWithReadings = [...state.siteReadings]
    // const sameIdIndex = cloneSiteWithReadings.findIndex(sWithReadings => sWithReadings.id === results[0].siteId)
    // if (sameIdIndex >= 0) {
    //   cloneSiteWithReadings.splice(sameIdIndex, 1, results[0])
    // } else {
    //   cloneSiteWithReadings.push(results[0])
    // }

    const newReadings = addOrUpdateSameKeyObjectInArray(state.siteReadings, results[0], 'id')
    commit(MutationNames.updateSiteReadings, newReadings)
  },
}

export default {
  name: ModuleNames.siteReadings,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
